module.exports = __webpack_public_path__ + "img/aws-sa-associate.776fe509.png";